import React, { useState, useEffect } from "react";
import { Location, getStatusInfo } from "../data/storeHours";

interface LocationStatusProps {
  location: Location;
  lang: "en" | "fr";
  hours: string;
  classPrefix: string;
}

const LocationStatus: React.FC<LocationStatusProps> = ({
  location,
  lang,
  hours,
  classPrefix,
}) => {
  const [status, setStatus] = useState(() => getStatusInfo(location, lang));

  useEffect(() => {
    const updateStatus = () => {
      setStatus(getStatusInfo(location, lang));
    };

    updateStatus();

    const interval = setInterval(updateStatus, 60000);

    return () => clearInterval(interval);
  }, [location, lang]);

  return (
    <div style={{ textAlign: "center" }}>
      <div
        className={`${
          classPrefix
        }-status ${status.isOpen ? "status-open" : "status-closed"}`}
      >
        <span className="status-indicator"></span>
        {status.message}
      </div>
      <div className={`${classPrefix}-hours`}>{hours}</div>
    </div>
  );
};

export default LocationStatus;
